import * as React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import GradeForm from './GradeForm';
import RegistrationFlowHeader from '../common/header/RegistrationFlowHeader';
import EscapeToSchoolEfLink from './EscapeToSchoolEfLink';
import KarteTracker from '../../../../../lib/KarteTracker';
import LearnerAndAccountRegistrationContainer from './LearnerAndAccountRegistrationContainer';

const stepMap = {
  '/': 1,
  '/learner': 1,
  '/verification': 2,
};

const RegistrationFlow: React.FC = () => {
  const location = useLocation();
  const karteTracker = new KarteTracker();

  React.useEffect(() => {
    // 学年選択画面はRailsの初期化時に計測されるためReact側では対象外とする
    if (location.pathname !== '/') {
      karteTracker.trackView();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div>
      <RegistrationFlowHeader
        steps={5}
        stepMap={stepMap}
        stepTitleKey="registration.personal_orders.header"
      />
      <div className="container">
        <div className="area aya-main">
          <div className="aya-form" id="sign-up-wizard">
            <Routes>
              <Route path="/" element={<GradeForm />} />
              <Route
                path="/*"
                element={<LearnerAndAccountRegistrationContainer />}
              />
            </Routes>
          </div>
        </div>
      </div>
      <EscapeToSchoolEfLink />
    </div>
  );
};

export default RegistrationFlow;
